export const WEEK_NUMBERS = [1, 2, 3, 4]
